module.exports = __webpack_public_path__ + "img/join-bg-desktop.c39b6291.svg";